// Page/component translations — Spanish (es)
export const pagesEs: Record<string, string> = {
  // COMMON
  loading: 'Cargando...',
  saving: 'Guardando...',
  deleting: 'Eliminando...',
  processing: 'Procesando...',
  errorLabel: 'Error',
  successLabel: 'Éxito',
  notAuthenticated: 'Usuario no autenticado',
  tryAgain: 'Inténtalo de nuevo',
  noData: 'Sin datos disponibles',
  copiedToClipboard: 'Copiado al portapapeles',
  requiredField: 'Campo obligatorio',
  invalidEmailMsg: 'Correo electrónico inválido',
  loadingVideos: 'Cargando videos...',
  noVideosFound: 'No se encontraron videos',
  unknownError: 'Error desconocido',
  confirmDelete: 'Confirmar eliminación',
  saveError: 'Error al guardar',
  loadingEllipsis: 'Cargando...',
  loadingDataEllipsis: 'Cargando datos...',

  // AUTH
  loginTitle: 'Accede a tu cuenta',
  loginSubtitle: 'Todo para escalar VSLs con automatización, protección y métricas.',
  loginSuccess: '¡Inicio de sesión exitoso!',
  loginError: 'Error al iniciar sesión. Verifica tus credenciales.',
  loginErrorGeneric: 'Error al iniciar sesión. Inténtalo de nuevo.',
  enterButton: 'Entrar',
  enteringButton: 'Entrando...',
  stayConnected: 'Mantenerme conectado',
  forgotPassword: '¿Olvidaste tu contraseña?',
  noAccount: '¿No tienes una cuenta?',
  createAccountFree: 'Crea tu cuenta gratis aquí ahora',
  signupTitle: 'Crea tu cuenta',
  signupSubtitle: 'Y empieza a convertir videos en conversiones reales.',
  signupSuccess: '¡Cuenta creada con éxito! Ahora elige tu plan para comenzar.',
  signupError: 'Error al crear la cuenta. Inténtalo de nuevo.',
  acceptTermsError: 'Debes aceptar los términos de uso para continuar.',
  passwordError: 'Las contraseñas deben ser iguales.',
  userAlreadyExists: 'Este usuario ya tiene cuenta en la plataforma.',
  nameTooShort: 'El nombre debe tener al menos 2 caracteres.',
  invalidCPF: 'CPF inválido.',
  invalidWhatsApp: 'WhatsApp inválido.',
  passwordTooShort: 'La contraseña debe tener al menos 8 caracteres.',
  alreadyHaveAccount: '¿Ya tienes una cuenta?',
  loginHereLink: 'Inicia sesión aquí',
  namePlaceholder: 'Nombre completo',
  emailPlaceholder: 'tuemail@dominio.com',
  passwordPlaceholder: 'Mín. 8 caracteres',
  emailLabel: 'Correo electrónico',
  passwordLabel: 'Contraseña',
  acceptTermsLabel: 'Acepto los términos de uso y la política de privacidad',

  // DASHBOARD / MY VIDEOS
  deleteVideoSuccess: '¡Video eliminado con éxito!',
  deleteVideoError: 'Error al eliminar video',
  moveVideoSuccess: '¡Video movido a la carpeta con éxito!',
  moveVideoError: 'Error al mover video a la carpeta',
  videoRemovedFromFolder: '¡Video eliminado de la carpeta!',
  searchVideosPlaceholder: 'Buscar videos...',
  noVideosInFolder: 'No hay videos en esta carpeta',
  newFolderLabel: 'Nueva carpeta',
  gridViewLabel: 'Vista en cuadrícula',
  listViewLabel: 'Vista en lista',
  myVideosPageTitle: 'Mis Videos',
  manageVideosSubtitle: 'Administra y visualiza tus últimos videos',

  // A/B TEST
  incompleteConfig: 'Configuración incompleta',
  mainVideoNotSelected: 'Video principal no seleccionado',
  abTestActive: 'Tu prueba A/B está activa',
  videoSelectionTab: 'Selección de videos',
  trafficDistributionTab: 'Distribución de tráfico',
  testDeletedMsg: 'Prueba eliminada',
  cannotDeleteTest: 'No se pudo eliminar la prueba',
  createFirstABTest: 'Crea tu primera prueba A/B',
  abTestEmptyDesc: 'Prueba diferentes versiones de tus VSLs y descubre qué convierte más',
  createABTestBtn: 'Crear Prueba A/B',
  howItWorksLink: '¿Cómo funciona?',
  trafficUpdatedSuccess: 'Distribución actualizada',
  trafficUpdatedDesc: 'La distribución de tráfico fue actualizada con éxito',
  selectMinVideos: 'Selecciona al menos 2 videos para la prueba',
  selectMaxVideos: 'Selecciona como máximo 6 videos para la prueba',
  dateNotAvailable: 'Fecha no disponible',
  invalidDate: 'Fecha inválida',
  runningStatus: 'En ejecución',
  finishedStatus: 'Finalizado',
  authError: 'Error de autenticación',

  // HOOK TRACK
  hookTestActive: 'Tu prueba de introducción está activa',
  hookTrackEmptyDesc: 'Prueba diferentes introducciones y descubre cuál retiene más la atención',
  createFirstHookTest: 'Crea tu primera prueba de hook',

  // VSLEADS
  loadStrategiesError: 'Error al cargar estrategias',
  strategyUpdatedToast: 'Estrategia actualizada',
  strategyUpdatedSuccessMsg: 'La estrategia fue actualizada con éxito.',
  strategyRemovedToast: 'Estrategia eliminada',
  loadingStrategies: 'Cargando estrategias...',
  leadCaptureTitle: 'Captura de Leads',
  captureWithEmailLabel: 'Captura con Email',
  captureWithPasswordLabel: 'Captura con Contraseña',
  loadStrategyError: 'Error al cargar estrategia',
  strategyUpdateSuccess: 'Estrategia actualizada con éxito',
  updateStrategyError: 'Error al actualizar estrategia',
  protectedContent: 'Contenido protegido',
  accessVideoBtn: 'Accede al video',
  strategyCreated: 'Estrategia creada con éxito',
  saveStrategyError: 'Error al guardar estrategia',

  // VSL CLOAKER
  loadVideosError: 'Error al cargar videos',
  loadRulesError: 'Error al cargar reglas',
  selectOriginalVideo: 'Selecciona el video original',
  ruleCreated: 'Regla creada con éxito',
  ruleDeleted: 'Regla eliminada con éxito',
  codesCopied: '¡Código copiado!',
  cloakerEmptyTitle: 'No hay reglas creadas',
  cloakerEmptyDesc: 'Crea reglas para filtrar y redirigir tráfico según criterios',

  // UPLOAD
  invalidFormat: 'Formato inválido',
  selectVideoFilesOnly: 'Selecciona solo archivos de video',
  videosAddedToast: 'Videos agregados',
  uploadsCompleted: 'Cargas completadas',
  maxFileSizeError: 'El archivo debe ser de máximo 100MB',
  unsupportedFormatMsg: 'Formato no compatible',
  videoNameLabel: 'Nombre del video',
  continueToCustomize: 'Continúa para personalizar tu video',
  myVideoDefault: 'Mi Video',

  // METRICS
  noRetentionData: 'Sin datos de retención en el período',
  noUTMData: 'Sin datos UTM en el período',
  expandPeriodTip: 'Intenta ampliar el período',
  saveErrorMsg: 'Error al guardar',
  videoTimeLabel: 'Tiempo del Video',
  retentionLabel: 'Retención (%)',

  // PLAYLIST
  playlistDeletedMsg: 'Playlist eliminada',
  playlistLinkCopied: 'Enlace de playlist copiado',
  playlistNotFound: 'Playlist no encontrada',
  videosAddedMsg: '¡Videos agregados!',
  videoRemovedMsg: 'Video eliminado',
  videosAddedSuccessDesc: 'Videos guardados con éxito.',
  embedCodeCopiedMsg: '¡Código copiado!',
  embedCodeCopiedDesc: 'Código de inserción copiado al portapapeles.',
  logoCompressed: 'Logo optimizado',
  logoError: 'Error al comprimir logo',
  faviconError: 'Error al comprimir favicon',
  addVideosTitle: 'Agregar videos',

  // SHARE VIDEO
  settingsSaved: '¡Configuraciones guardadas!',
  generatingPublicLink: 'Generando enlace público',
  activatingMetrics: 'Activando métricas',
  videoPreparing: 'Video en preparación',
  copiesLabel: 'copias',
  copyLabel: 'copia',

  // WEBINAR
  invalidWhatsAppField: 'WhatsApp inválido',
  registrationSuccess: '¡Inscripción realizada!',
  redirectingToRoom: 'Serás redirigido a la sala...',
  formError: 'Error en el formulario',

  // NOTIFICATIONS
  notificationsSaved: 'Preferencias guardadas',
  notificationsEnabled: '¡Notificaciones activadas!',
  notificationPermissionNeeded: 'Permiso requerido',
  testNotification: 'Notificación de prueba',
  installAvailable: 'HostVSL se está instalando',
  installInfo: 'Puedes acceder a HostVSL desde tu pantalla de inicio',
  installNotAvailable: 'Instalación no disponible',

  // FEATURE CONFIGS
  urlInvalid: 'URL inválida',
  unsupportedImageFormat: 'Formato no compatible. Usa PNG o JPG',
  thumbnailConfigured: 'Miniatura de inicio configurada',
  buttonAdded: 'Botón agregado',
  buttonRemoved: 'Botón eliminado',
  videoIdNotFound: 'ID de video no encontrado',

  // DASHBOARD EMPTY STATES
  emptyDashboardTitle: 'No se encontraron videos',
  emptyDashboardSubtitle: 'Sube tu primer video para comenzar',
  uploadFirstVideo: 'Subir primer video',

  // PROFILE
  profileSaved: 'Perfil guardado',
  passwordChangedSuccess: 'Contraseña cambiada con éxito',
  photoChangedSuccess: 'Foto cambiada',
  photoRemovedSuccess: 'Foto eliminada',

  // PIXEL
  pixelPageTitle: 'Configuración de Pixel',
  pixelPageSubtitle: 'Configura píxeles de seguimiento para monitorear conversiones',

  // METRICS PAGE
  metricsPageTitle: 'Métricas',
  selectVideoMetrics: 'Selecciona un video para ver las métricas',

  // DOMAIN PROTECTION
  domainProtectionTitle: 'Protección de Dominios',

  // TRACKING
  trackingTitle: 'Seguimiento',

  // FINANCE
  financeTitle: 'Finanzas',

  // PARTNERS
  partnersTitle: 'Socios',

  // NOT FOUND
  pageNotFound: 'Página no encontrada',
  goHome: 'Volver al inicio',

  // AB TEST LIST
  abTestListTitle: 'Tus Pruebas A/B',
  createNewTest: 'Crear nueva prueba',
  noABTestsFound: 'No se encontraron pruebas A/B',
  createFirstABTestDesc: 'Crea tu primera prueba A/B para comparar diferentes versiones de videos.',
  copyCode: 'Copiar Código',
  rename: 'Renombrar',
  viewMetrics: 'Ver Métricas',
  deleteABTestTitle: '¿Eliminar prueba A/B?',
  deleteTestConfirm: 'Esta acción eliminará permanentemente esta prueba y todos sus datos. Esta acción no puede deshacerse.',
  confirmDeleteTest: 'Sí, eliminar prueba',
  abTestCodeCopiedDesc: 'El código de la prueba A/B ha sido copiado al portapapeles.',
  abTestDeletedDesc: 'La prueba A/B ha sido eliminada con éxito.',
  deleteErrorTitle: 'Error al eliminar',
  testRenamedTitle: 'Prueba renombrada',
  testRenamedDesc: 'El nombre de la prueba ha sido actualizado con éxito.',
  renameErrorTitle: 'Error al renombrar',
  renameTestError: 'No se pudo renombrar la prueba.',
  copyCodeErrorTitle: 'Error al copiar código',
  noVideosInTest: 'Esta prueba no tiene videos asociados.',
  featureInDevelopment: 'En desarrollo',
  toggleStatusDev: 'La función de activar/desactivar está en desarrollo.',
  duplicateDev: 'La función de duplicar está en desarrollo.',

  // HOOK TRACK LIST
  hookTrackListTitle: 'Tus Pruebas de Introducción',
  createHookTest: 'Crear Prueba de Hook',
  noHookTestsDesc: 'Aún no has creado ninguna prueba de hook.',
  createFirstHookLabel: 'Crear tu primera prueba',
  deleteHookTestTitle: '¿Eliminar prueba de hook?',
  hookTestDeletedDesc: 'La prueba ha sido eliminada con éxito.',
  hookRenameTestError: 'No se pudo actualizar el nombre de la prueba.',
  statusUpdatedTitle: 'Estado actualizado',
  statusUpdatedDesc: 'El estado de la prueba ha sido actualizado.',
  duplicateSoon: 'Funcionalidad de duplicación próximamente.',
  testWithoutName: 'Prueba sin nombre',

  // MY VIDEOS V2
  removeFromFolderError: 'Error al eliminar video de la carpeta',
};
